import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Badge, Card, Dropdown, Grid, Icon, Nav, Page, Site} from 'tabler-react';
import { NavLink, withRouter } from 'react-router-dom';
import Cookies from 'js-cookie';
import UserCard from '../../UserCard';
import fetch from '../../../support/fetch';

import logo from '../../../assets/images/logo.png';
import './index.sass';

const propTypes = {
    user: PropTypes.object,
    options: PropTypes.node,
    withSidebar: PropTypes.bool
};

const defaultProps = {
    withSidebar: true
};

/**
 * Options of User account dropDown
 * @type {[*]}
 */
const accountNavItems = [
    // {
    //     icon: "user",
    //     value: "Visitar Perfil",
    //     to: 'http://www.ooppah.com/artistas',
    //     LinkComponent: withRouter(NavLink)
    // },
    // {isDivider: true},
    {value: "Alterar E-mail", to: "/change-email", LinkComponent: withRouter(NavLink)},
    {value: "Alterar Senha", to: "/change-password", LinkComponent: withRouter(NavLink)},
    {isDivider: true},
    {
        icon: "help-circle",
        value: "Precisa de ajuda?",
        to: "https://ooppah.zendesk.com/hc/pt-br",
        LinkComponent: withRouter(NavLink)
    },
    {icon: "log-out", value: "Finalizar Sessão", to: "/logout", LinkComponent: withRouter(NavLink) },
];

/**
 * Default nav items
 * @type {[*]}
 */
const navItems = [
    {value: 'MEU PERFIL', icon: 'user', to: 'https://profile.ooppah.com/profile'},
    {value: 'Dashboard', icon: 'home', to: '/home', LinkComponent: withRouter(NavLink)},
    {value: 'Minhas Assinaturas', icon: 'check', to: '/subscriptions', LinkComponent: withRouter(NavLink)},
    {value: 'Cartão de Crédito', icon: 'credit-card', to: '/credit-card/new', LinkComponent: withRouter(NavLink)},
    // {value: 'Estatísticas', icon: 'pie-chart', to: '/stats', LinkComponent: withRouter(NavLink)},
    {value: 'Logout', to: '/logout', LinkComponent: withRouter(NavLink)}
];

class AuthenticatedTemplate extends Component {

    state = {
        ready: false
    };

    onMenuToggleClick = (e) => {
        // console.log('Toggle menu clicked...')
    };

    /**
     * Authenticated user data.
     * @type {{}}
     */
    user = {};

    /**
     * Token info.
     * @type {{}}
     */
    tokenInfo = {};

    constructor(props) {
        super(props);

        let tokenInfo = JSON.parse(sessionStorage.getItem('ooppah_user_token'));

        if (tokenInfo === null) {
            //console.log('tokenInfo === null');
            if (Cookies.get('ooppah_token') === undefined || Cookies.get('ooppah_token') === null) {
                //console.log('Nao ha Cookie ooppah_token');
                window.location = '/';
            } else {
                //console.log('Cookie ooppah_token encontrado');
                tokenInfo = {
                    "token": Cookies.get('ooppah_token'),
                    "type": Cookies.get('ooppah_token_type'),
                    "expires_at": Cookies.get('ooppah_token_expires')
                }
                sessionStorage.setItem("ooppah_user_token", JSON.stringify(tokenInfo));
            }
        } else {
            //console.log('tokenInfo !== null');
            this.tokenInfo = tokenInfo;
            this.user = JSON.parse(sessionStorage.getItem('ooppah_user_info'));
        }
    }

    componentWillMount() {
        this.collectUserData(this.tokenInfo);
    }

    collectUserData = (tokenInfo) => {
        fetch.initialize().obj({
            query: `
            query FetchSubscriberInfo {
                subscriber {
                    initials
                    name
                    activated
                    isMinor
                    document
                    email
                    phone
                    guardian {
                      name
                      birthday
                      document
                      documentIssuer
                      documentShippingDate
                    }
                    address {
                      street
                      number
                      complement
                      district
                      city
                      state
                      zipCode
                    }
                }
            }`
        })
        .then(res => {
            if (res.hasOwnProperty('errors')) {
                console.log('userCollectData Error', res.errors[0].debugMessage);
                return;
            }

            // store the authenticated user info...
            sessionStorage.setItem("ooppah_user_info", JSON.stringify(res.data.subscriber));
            this.user = JSON.parse(sessionStorage.getItem('ooppah_user_info'));
            //console.log('setItem ooppah_user_info', this.user);
            if (this.user === undefined || this.user === null || this.user === {}) {
                //console.log('this.user === undefined or null or {}');
                window.location = '/';
            } else {
                //console.log('this.setState ready true');
                this.setState({'ready': true});
            }
        });
    };

    render() {
        return (
            <Page>
            {
                this.state.ready &&
                <Page.Main>
                    <Site.Header>
                        <Site.Logo src={logo} href="/home" alt="Account | Ooppah" />

                        <div className="d-flex order-lg-2 ml-auto">
                            <Dropdown
                                isNavLink
                                triggerClassName="pr-0 leading-none"
                                triggerContent={
                                    <React.Fragment>
                                        <Avatar>{this.user.initials}</Avatar>
                                            <span className="ml-2 d-none d-lg-block">
                                            <span className="text-default">{this.user.name}</span>
                                            <small className="text-muted d-block mt-1">{this.user.email}</small>
                                        </span>
                                    </React.Fragment>
                                }
                                position="bottom-end"
                                arrow={true}
                                arrowPosition="right"
                                toggle={false}
                                itemsObject={accountNavItems}
                            />
                            <a
                                className="header-toggler d-lg-none ml-3 ml-lg-0"
                                onClick={this.onMenuToggleClick}
                            >
                                <span className="header-toggler-icon" />
                            </a>
                        </div>
                    </Site.Header>

                    <Site.Nav>
                        <Grid>
                            <Grid.Row>
                                <Grid.Col className="col-lg">
                                    <Nav
                                        className="border-0"
                                        itemsObjects={navItems}
                                    />
                                </Grid.Col>
                            </Grid.Row>
                        </Grid>
                    </Site.Nav>

                    <Page.Content title={this.props.title} options={this.props.options}>
                        <Grid>
                            <Grid.Row>
                                {
                                    this.props.withSidebar &&
                                    <Grid.Col width={12} md={4}>
                                        <UserCard user={this.user} />
                                    </Grid.Col>
                                }
                                <Grid.Col width={12} md={this.props.withSidebar ? 8 : 12}>
                                    {this.props.children}
                                </Grid.Col>
                            </Grid.Row>
                        </Grid>
                    </Page.Content>

                    <footer className="footer">
                        <div className="container">
                            <div className="row align-items-center flex-row-reverse">
                                <div className="col-auto ml-lg-auto">
                                    <div className="row align-items-center">
                                        <div className="col-auto">
                                            <ul className="list-inline list-inline-dots mb-0">
                                                <li className="list-inline-item"><a href="https://www.ooppah.com.br" target="_blank">Site</a></li>
                                                {/*<li className="list-inline-item"><a href="https://www.ooppah.com.br/backend" target="_blank">Backend</a></li>*/}
                                                <li className="list-inline-item"><a href="https://ooppah.zendesk.com/hc/pt-br" target="_blank">Suporte</a></li>
                                            </ul>
                                        </div>
                                        <div className="col-auto">
                                            <a href="https://github.com/zabaala" target="_blank" className="btn btn-outline-primary btn-sm">
                                                With <span className="text-red">❤</span> by @zabaala
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-auto mt-3 mt-lg-0">
                                    Account é um produto <a href=".">Ooppah.com</a>.<br />
                                    Copyright © 2016-2019 | Todos os direitos reservados.
                                </div>
                            </div>
                        </div>
                    </footer>
                </Page.Main>
            } {/** End state.ready */}
            </Page>
        );
    }
}

AuthenticatedTemplate.propTypes = propTypes;
AuthenticatedTemplate.defaultProps = defaultProps;

export default AuthenticatedTemplate
